import classNames from "classnames";
import times from "lodash/times";
import { utc } from "PFCore/helpers/date";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";

import css from "./day_strips.module.scss";

// Sentinel ISO date strings used when availabilityInfo is missing.
// "9999" sorts after any real ISO date, "0000" sorts before any real ISO date,
// which makes the (start <= iso && iso <= end) range check evaluate to false.
const FUTURE_DATE_SENTINEL = "9999";
const PAST_DATE_SENTINEL = "0000";

type DayStripsProps = {
  startDate: string;
  dayWidth: number;
  calculatedMonthsLimit: number;
  matchMonthsLimit?: number;
  showToday?: boolean;
  availabilityInfo?: { start?: string; end?: string };
};

export const DayStrips = ({
  startDate,
  availabilityInfo,
  dayWidth,
  calculatedMonthsLimit,
  matchMonthsLimit = 0,
  showToday
}: DayStripsProps) => {
  const days = Math.ceil(calculatedMonthsLimit * 31) + 21; // + 3 weeks padding just in case
  const start = availabilityInfo ? availabilityInfo.start : FUTURE_DATE_SENTINEL;
  const end = availabilityInfo ? availabilityInfo.end : PAST_DATE_SENTINEL;
  const style = { width: dayWidth };
  const { formatDate, formatISODate } = useDateFormatter();

  return (
    <div className={css.root}>
      {times(days, (i) => {
        const date = utc(startDate).add(i, "days");
        const iso = formatISODate(date);
        const isWeekend = date.day() === 0 || date.day() === 6;
        const inRange = (start ?? FUTURE_DATE_SENTINEL) <= iso && iso <= (end ?? PAST_DATE_SENTINEL);
        const formatedDate = formatDate(date);
        const isToday = formatedDate === formatDate();
        const matchMonthsLimitDate = utc().add(matchMonthsLimit, "months").endOf("month");
        const offLimit = matchMonthsLimit && date > matchMonthsLimitDate;

        return (
          <div
            title={formatedDate}
            key={iso}
            style={style}
            className={classNames(css.day, {
              [css.weekend]: isWeekend,
              [css.req]: inRange,
              [css.offLimit]: offLimit,
              [css.today]: showToday && isToday
            })}
          />
        );
      })}
    </div>
  );
};
